// // src/components/BrandAudit/BrandAuditWizard.js
// import React, { useState, useCallback, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useApp } from '../../contexts/AppContext';
// import { auditAPI } from '../../services/api';
// import BrandInfo   from './BrandInfo';
// import GMBProfile  from './GMBProfile';
// import Competitors from './Competitors';
// import OverallScores from './OverallScores';
// import DomainAuthorityPage from './DomainAuthorityPage';
// import PageSpeedPage from './PageSpeedPage';
// import TechnicalSEOPage from './TechnicalSEOPage';
// import GmbAuditPage from './GmbAuditPage'
// import AIVisibilityPage from './AIVisibilityPage';
// import FinalVerdict from './FinalVerdict';
// import { normalizeBrandName } from '../../utils/normalizeBrandName';
// import ShareButton from './ShareButton';
// import '../../BrandPulse.css';

// // ─────────────────────────────────────────────────────────────────────────
// // Helper functions (same as old AuditFormNew)
// // ─────────────────────────────────────────────────────────────────────────
// const cleanDomain = (url) =>
//   url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// // const buildFormData = (brandName, tags, websiteUrl, location, gmbLink, competitors) => {
// //   const locations = [{ city: location || '', gmbLink: gmbLink || '' }];
// //   const competitorUrls = competitors.map(c => c.website || '').filter(Boolean);
// //   return { brandName, websiteUrl, locations, pillarKeywords: tags, competitors: competitorUrls };
// // };

// const buildFormData = (brandName, tags, websiteUrl, location, gmbLink, competitors, placeId) => {
//   const locations = [{ city: location || '', gmbLink: gmbLink || '' }];
//   const competitorUrls = competitors.map(c => c.website || '').filter(Boolean);
//   return { brandName, websiteUrl, locations, pillarKeywords: tags, competitors: competitorUrls, placeId };
// };


// const persistAuditData = (brandName, tags, websiteUrl, location, gmbLink, competitors, setLastAuditInfo,placeId) => {
//   const formData = buildFormData(brandName, tags, websiteUrl, location, gmbLink, competitors);
//   localStorage.setItem('auditFormData', JSON.stringify(formData));
//   const auditInfo = {
//     brandName,
//     domain: websiteUrl,
//     location: location || '',
//     competitorCount: formData.competitors.length,
//     auditDate: new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
//   };
//   localStorage.setItem('lastAuditInfo', JSON.stringify(auditInfo));
//   setLastAuditInfo(auditInfo);
// };

// const loadSavedData = () => {
//   const saved = localStorage.getItem('auditFormData');
//   if (!saved) return null;
//   try {
//     const data = JSON.parse(saved);
//     return {
//       brandName: data.brandName || '',
//       tags: data.pillarKeywords || [],
//       websiteUrl: data.websiteUrl || '',
//       location: data.locations?.[0]?.city || '',
//       gmbLink: data.locations?.[0]?.gmbLink || '',
//       competitorUrls: data.competitors || [],
//     };
//   } catch { return null; }
// };

// // Helper to extract and normalize authority metrics (copy from DomainAuthorityPage)
// const extractAuthorityMetrics = (response, domain) => {
//   const d = response?.data;
//   if (!d) return null;
//   // Try various response shapes (same as DomainAuthorityPage)
//   if (d.data?.domain_authority !== undefined) return d.data;
//   if (d.domain_authority !== undefined) return d;
//   if (d.data && typeof d.data === 'object') {
//     if (d.data[domain]?.domain_authority !== undefined) return d.data[domain];
//     const key = Object.keys(d.data).find(k => k !== 'insights' && d.data[k]?.domain_authority);
//     if (key) return d.data[key];
//   }
//   if (d[domain]?.domain_authority !== undefined) return d[domain];
//   if (d.success && d.data) {
//     const inner = d.data;
//     if (inner.domain_authority !== undefined) return inner;
//     if (inner[domain]?.domain_authority !== undefined) return inner[domain];
//   }
//   return null;
// };

// const normalizeAuthorityData = (raw, domain) => {
//   const cap = (v) => Math.min(Math.max(parseInt(v) || 0, 0), 100);
//   return {
//     domain:           raw.domain ?? domain,
//     domain_authority: cap(raw.domain_authority),
//     page_authority:   cap(raw.page_authority),
//     spam_score:       cap(raw.spam_score),
//     spam_risk:        raw.spam_risk ?? 'UNKNOWN',
//     referring_domains: parseInt(raw.referring_domains) || 0,
//     total_backlinks:   parseInt(raw.total_backlinks)   || 0,
//     domain_age_years:  parseFloat(raw.domain_age_years) || 0,
//     source:           raw.source ?? 'unknown',
//     insights:         raw.insights ?? '',
//   };
// };

// const cacheDomainAuthority = (domain, response) => {
//   try {
//     const raw = extractAuthorityMetrics(response, domain);
//     if (raw) {
//       const normalized = normalizeAuthorityData(raw, domain);
//       const cacheKey = `domainAuthority_${domain}`;
//       localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), d: normalized }));
//       console.log(`✅ Cached Domain Authority for ${domain}`);
//     } else {
//       console.warn(`⚠️ Could not extract authority metrics for ${domain}`);
//     }
//   } catch (e) { console.warn('Cache Domain Authority failed', e); }
// };


// // ─────────────────────────────────────────────────────────────────────────
// // Cache helpers (matching LoadingScreen)
// // ─────────────────────────────────────────────────────────────────────────
// const cachePageSpeed = (domain, response) => {
//   try {
//     const cacheKey = `pageSpeedRaw_${domain}`;
//     const domainKey = domain in response.data ? domain : Object.keys(response.data)[0];
//     const pageData = response.data[domainKey];
//     if (pageData) {
//       localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: pageData }));
//     }
//   } catch (e) { console.warn('Cache PageSpeed failed', e); }
// };

// const cacheTechnicalSEO = (domain, response) => {
//   try {
//     const cacheKey = `technicalSEO_${cleanDomain(domain)}`;
//     const techData = response?.data || response;
//     if (!techData) return;
//     const summary = techData.summary_card || {};
//     const metrics = techData.metrics || {};
//     const mapped = {
//       pages_indexed: summary.pages_indexed?.value ?? 0,
//       schema_count: summary.schema_markup?.count ?? 0,
//       broken_links: summary.broken_links?.count ?? 0,
//       alt_coverage: summary.image_alt_coverage?.coverage ?? 0,
//       ssl_status: {
//         status: summary.https_ssl?.status === 'Secure' ? 'Secure' : (summary.https_ssl?.status === 'Expiring Soon' ? 'Expiring Soon' : 'Unknown'),
//         details: summary.https_ssl?.expires_in_days ? `Certificate expires in ${summary.https_ssl.expires_in_days} days` : '',
//       },
//       robots_txt: {
//         status: metrics.robots_txt?.status === 'present' ? 'Present' : 'Missing',
//         url: `${domain}/robots.txt`,
//         details: metrics.robots_txt?.analysis?.sitemap_references?.length ? 'Sitemap referenced' : '',
//       },
//       sitemap: {
//         status: summary.sitemap?.status === 'Present' ? 'Present' : 'Missing',
//         url: `${domain}/sitemap.xml`,
//         details: summary.sitemap?.url_count ? `${summary.sitemap.url_count} URLs` : '',
//       },
//       google_analytics: { detected: metrics.google_analytics?.detected ?? false, id: metrics.google_analytics?.measurement_id || '' },
//       google_tag_manager: { detected: metrics.google_tag_manager?.detected ?? false, id: metrics.google_tag_manager?.container_id || '' },
//       meta_pixel: { detected: metrics.meta_pixel?.detected ?? false },
//       mobile_usability: { status: summary.mobile_usability?.status === 'Pass' ? 'Pass' : 'Issues Found', details: '' },
//       core_web_vitals: { status: summary.core_web_vitals?.status === 'Pass' ? 'Pass' : 'Fail', details: '' },
//       schema_markup_types: { found: summary.schema_markup?.types || [], missing: summary.schema_markup?.missing || [], count: summary.schema_markup?.count ?? 0 },
//       meta_title_issues: { count: summary.meta_title_issues?.count ?? 0, details: summary.meta_title_issues?.display || '' },
//       canonical_tags: { status: metrics.canonical_issues?.status === 'good' ? 'Present' : 'Needs Improvement', details: '' },
//       broken_links_details: { count: summary.broken_links?.count ?? 0, internal: 0, external: 0 },
//       insight: techData.ai_insight?.insight || '',
//     };
//     localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: mapped }));
//   } catch (e) { console.warn('Cache TechnicalSEO failed', e); }
// };

// // Placeholder for GMB ranking (similar to LoadingScreen's get_ranking)
// // const cacheGmbRanking = (keyword, location, placeId, response) => {
// //   // We'll store a simplified version; the actual ranking data structure can be matched later
// //   try {
// //     const cacheKey = `gmbRanking_${keyword}_${location}_${placeId}`;
// //     localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: response?.data || response }));
// //   } catch (e) { console.warn('Cache GMB ranking failed', e); }
// // };

// const cacheGmbRanking = (keyword, location, placeId, domain, gridRadius = 1.5, response) => {
//   try {
//     const centerKey = 'default';
//     const cacheKey = `gmbRanking_${domain}_${placeId}_${keyword}_${centerKey}_${gridRadius}`;

//     const rankingData = response?.data;
//     let grid = null, centerCellTop = [], center = null;

//     if (rankingData?.ranking?.results?.brand?.grid) {
//       grid         = rankingData.ranking.results.brand.grid;
//       centerCellTop = rankingData.ranking.center_cell_top || [];
//       center        = rankingData.ranking.center;
//     } else if (rankingData?.results?.brand?.grid) {
//       grid         = rankingData.results.brand.grid;
//       centerCellTop = rankingData.center_cell_top || [];
//       center        = rankingData.center;
//     }

//     localStorage.setItem(cacheKey, JSON.stringify({
//       timestamp: Date.now(),
//       data: { grid, centerCellTop, center }
//     }));
//     console.log(`✅ Cached GMB Ranking: ${cacheKey}`);
//   } catch (e) {
//     console.warn('Cache GMB ranking failed', e);
//   }
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Main Component
// // ─────────────────────────────────────────────────────────────────────────
// const BrandAuditWizard = () => {
//   const navigate = useNavigate();
//   const { setLastAuditInfo } = useApp();

//   const [step, setStep] = useState(1);

//   // Step 1 data
//   const [brandName, setBrandName] = useState('');
//   const [tags, setTags] = useState([]);

//   // Step 2 data
//   const [websiteUrl, setWebsiteUrl] = useState('');
//   const [location, setLocation] = useState('');
//   const [placeId, setPlaceId] = useState('');
//   const [gmbLink, setGmbLink] = useState('');
//   const [gmbData, setGmbData] = useState(null);
//   const [gmbLoading, setGmbLoading] = useState(false);
//   const [fullAddress, setFullAddress] = useState('');  
//   const [scoresLoading, setScoresLoading] = useState(false);  
//   // Step 3 data
//   const [competitors, setCompetitors] = useState([]);
//   const [compLoading, setCompLoading] = useState(false);

//   // ─── Load saved data on mount ─────────────────────────────────────────
//   useEffect(() => {
//     const saved = loadSavedData();
//     if (saved) {
//       setBrandName(saved.brandName);
//       setTags(saved.tags);
//       setWebsiteUrl(saved.websiteUrl);
//       setLocation(saved.location);
//       setGmbLink(saved.gmbLink);
//       // ✅ Only restore competitors if they belong to the same brand
//       const savedCompetitors = localStorage.getItem('competitors_list');
//       const savedBrand = localStorage.getItem('competitors_brand');
    
//       if (savedCompetitors && savedBrand === saved.brandName) {
//         try { setCompetitors(JSON.parse(savedCompetitors)); } catch {}
//       } 
//         else {
//         // Different brand — clear stale competitors
//         localStorage.removeItem('competitors_list');
//         localStorage.removeItem('competitors_brand');
//         setCompetitors([]);
//         }
//     }
//     }, []);

// //       else if (saved.competitorUrls.length) {
// //         const comps = saved.competitorUrls.map((url, idx) => ({
// //           id: Date.now() + idx,
// //           website: url,
// //           name: '',
// //           rating: 0,
// //           reviews: 0,
// //           isManual: true,
// //         }));
// //         setCompetitors(comps);
// //         localStorage.setItem('competitors_list', JSON.stringify(comps));
// //       }
// //     }
// //   }, []);

//   // ─── Persist data whenever important state changes ────────────────────
//   useEffect(() => {
//     if (brandName && tags.length) {
//       persistAuditData(brandName, tags, websiteUrl, location, gmbLink, competitors, setLastAuditInfo,placeId);
//     }
//     if (competitors.length) {
//       localStorage.setItem('competitors_list', JSON.stringify(competitors));
//     }
//   }, [brandName, tags, websiteUrl, location, gmbLink, competitors, setLastAuditInfo,placeId]);

//   const advance = (nextStep) => {
//     setStep(nextStep);
//     setTimeout(() => {
//       const el = document.getElementById(`card-${nextStep}`);
//       if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }, 50);
//   };

//   // ─── Step 1 complete ──────────────────────────────────────────────────
//   const handleBrandComplete = useCallback(({ brandName: bn, tags: t, websiteUrl: wu, placeId: pid, location: loc, fullAddress: fa, gmbLink: gl }) => {
    
//     // ✅ If brand changed, wipe stale caches so nothing bleeds through
//     const prevBrand = localStorage.getItem('competitors_brand');
//     if (prevBrand && prevBrand !== bn) {
//         console.log(`🔄 Brand changed from "${prevBrand}" to "${bn}" — clearing caches`);
//         localStorage.removeItem('competitors_list');
//         localStorage.removeItem('competitors_brand');
//         // Clear audit caches so new brand gets fresh data
//         const prevDomain = cleanDomain(localStorage.getItem('auditFormData')
//         ? JSON.parse(localStorage.getItem('auditFormData')).websiteUrl : '');
//         if (prevDomain) {
//         localStorage.removeItem(`domainAuthority_${prevDomain}`);
//         localStorage.removeItem(`pageSpeedRaw_${prevDomain}`);
//         localStorage.removeItem(`technicalSEO_${prevDomain}`);
//         localStorage.removeItem(`overallScore_${prevDomain}`);
//         clearAIVisibilityCache(prevDomain);
//         }
//         setCompetitors([]);
//     }
    
//     //setBrandName(bn);
//     setBrandName(normalizeBrandName(bn));
//     setTags(t);
//     setWebsiteUrl(wu);
//     setPlaceId(pid);
//     setLocation(loc);
//     setFullAddress(fa);
//     setGmbLink(gl);
//     advance(2);
//   }, []);

//   const clearAIVisibilityCache = (domain) => {
//   if (!domain) return;
//   const prefix = `aiVisibility_${domain}_`;
//   const keysToRemove = [];
//   for (let i = 0; i < localStorage.length; i++) {
//     const key = localStorage.key(i);
//     if (key && key.startsWith(prefix)) {
//       keysToRemove.push(key);
//     }
//   }
//   keysToRemove.forEach(k => localStorage.removeItem(k));
//   if (keysToRemove.length > 0) {
//     console.log(`🗑️ Cleared ${keysToRemove.length} AI visibility cache entries for ${domain}`);
//   }
// };

//   // ─── Step 2 complete ──────────────────────────────────────────────────
// //   const handleGMBConfirm = useCallback(async (confirmedData) => {
// //     if (confirmedData) setGmbData(confirmedData);
// //     advance(3);    
// //     setCompLoading(true);
// //     try {
// //       const res = await auditAPI.autoDiscover({
// //         domain: cleanDomain(websiteUrl) || websiteUrl,
// //         brand: brandName,
// //         location: location,
// //         pillar_keywords: tags,
// //         brand_rating:  resolvedGmbData?.rating              ?? 
// //                        resolvedGmbData?.reviews?.rating     ?? 0,
// //         brand_reviews: resolvedGmbData?.user_ratings_total  ?? 
// //                        resolvedGmbData?.reviews?.count      ?? 0,
// //         force_refresh: true,
// //       });
      
// //     const data = res?.data?.data || res?.data || {};
// //     const rawCompetitors = data.competitors || [];
// //     const mappedCompetitors = rawCompetitors.map((c, idx) => ({
// //       id:       c.place_id || Date.now() + idx,
// //       name:     c.name || '',
// //       website:  c.website || '',
// //       rating:   c.rating || 0,
// //       reviews:  c.user_ratings_total || 0,
// //       isManual: false,
// //     }));

// //     setCompetitors(mappedCompetitors);
// //     localStorage.setItem('competitors_list', JSON.stringify(mappedCompetitors));
// //     localStorage.setItem('competitors_brand', brandName); // ✅ tag with brand
// //   } catch (err) {
// //     console.error('Competitor fetch failed', err);
// //   } finally {
// //     setCompLoading(false);
// //   }
// // }, [brandName, location, tags]);

//     const handleGMBConfirm = useCallback(async (confirmedData) => {
//     const resolvedGmbData = confirmedData || gmbData;
//     if (confirmedData) setGmbData(confirmedData);
//     advance(3);    
//     setCompLoading(true);
//     try {
//         console.log("domain",websiteUrl)
//         console.log("Brand",brandName)
        
//       // const res = await auditAPI.autoDiscover({
//       //   domain: cleanDomain(websiteUrl) || websiteUrl,   // ── NEW
//       //   brand: brandName,
//       //   location: location,
//       //   pillar_keywords: tags,
//       //   force_refresh: true,
//       //   // ── NEW: pass brand strength so backend filters weak competitors ──
//       //   brand_rating:  resolvedGmbData?.rating              ?? 
//       //                  resolvedGmbData?.reviews?.rating     ?? 0,
//       //   brand_reviews: resolvedGmbData?.user_ratings_total  ?? 
//       //                  resolvedGmbData?.reviews?.count      ?? 0,
//       // });
//       const res = await auditAPI.autoDiscover({
//         domain: cleanDomain(websiteUrl) || websiteUrl,
//         brand: brandName,
//         location: location,
//         pillar_keywords: tags,
//         force_refresh: true,
//         place_id: placeId,          // ← ADD THIS
//         brand_rating:  resolvedGmbData?.rating ?? resolvedGmbData?.reviews?.rating ?? 0,
//         brand_reviews: resolvedGmbData?.user_ratings_total ?? resolvedGmbData?.reviews?.count ?? 0,
//       });
      
//     const data = res?.data?.data || res?.data || {};
//     const rawCompetitors = data.competitors || [];
//     const mappedCompetitors = rawCompetitors.map((c, idx) => ({
//       id:       c.place_id || Date.now() + idx,
//       name:     normalizeBrandName(c.name || ''),   // ── normalize competitor names too
//       website:  c.website || '',
//       rating:   c.rating || 0,
//       reviews:  c.user_ratings_total || 0,
//       isManual: false,
//     }));

//     setCompetitors(mappedCompetitors);
//     localStorage.setItem('competitors_list', JSON.stringify(mappedCompetitors));
//     localStorage.setItem('competitors_brand', brandName);
//   } catch (err) {
//     console.error('Competitor fetch failed', err);
//   } finally {
//     setCompLoading(false);
//   }
// }, [brandName, location, tags, gmbData]);  // ── added gmbData to deps


//     const handleUpdateCompetitors = useCallback((updated) => {
//     setCompetitors(updated);
//     localStorage.setItem('competitors_list', JSON.stringify(updated));
//     localStorage.setItem('competitors_brand', brandName); // ✅ tag with current brand
//     }, [brandName]);


//   // ─── Step 3 complete – fire background API calls for PageSpeed, Technical SEO, Ranking ───
// //   const handleCompetitorsConfirm = useCallback(async () => {
// //         setScoresLoading(true);
// //         console.log('🚀 Starting background audits (PageSpeed, Technical SEO, GMB Ranking)...');

// //         // Get keyword from state, fallback to localStorage
// //         let firstKeyword = tags.length > 0 ? tags[0] : null;
// //         if (!firstKeyword) {
// //             try {
// //             const stored = localStorage.getItem('auditFormData');
// //             if (stored) {
// //                 const formData = JSON.parse(stored);
// //                 const pill = formData.pillarKeywords;
// //                 if (pill && pill.length) firstKeyword = pill[0];
// //             }
// //             } catch (e) {}
// //         }
// //         console.log('📌 Using keyword for ranking:', firstKeyword);

// //         const brandDomain = cleanDomain(websiteUrl) || websiteUrl;
// //         const domainsToFetch = [brandDomain];
// //         competitors.forEach(comp => {
// //             if (comp.website) {
// //             const compDomain = cleanDomain(comp.website) || comp.website;
// //             domainsToFetch.push(compDomain);
// //             }
// //         });
// //         const uniqueDomains = [...new Set(domainsToFetch)];
// //         console.log('🌐 Domains for PageSpeed:', uniqueDomains);

// //         try {

// //             const authorityPromises = uniqueDomains.map(async (domain) => {
// //             try {
// //                 const res = await auditAPI.authorityAnalysis({ BrandURL: `https://${domain}` });
// //                 console.log(`✅ Authority response for ${domain}:`, res?.data || res);
// //                 cacheDomainAuthority(domain, res);
// //             } catch (err) {
// //                 console.warn(`❌ Authority failed for ${domain}:`, err);
// //             }
// //             });
// //             await Promise.all(authorityPromises);

// //             // 1. PageSpeed for brand and competitors (parallel)
// //             const pageSpeedPromises = uniqueDomains.map(async (domain) => {
// //             try {
// //                 const res = await auditAPI.pagespeedAnalysis({ domain });
// //                 console.log(`✅ PageSpeed response for ${domain}:`, res?.data || res);
// //                 cachePageSpeed(domain, res);
// //                 return res;
// //             } catch (err) {
// //                 console.warn(`❌ PageSpeed failed for ${domain}:`, err);
// //             }
// //             });
// //             await Promise.all(pageSpeedPromises);

// //             // 2. Technical SEO for brand only
// //             if (brandDomain) {
// //             console.log('🔧 Fetching Technical SEO for:', brandDomain);
// //             try {
// //                 const techRes = await auditAPI.technicalseo({ domain: brandDomain });
// //                 console.log('✅ Technical SEO response:', techRes?.data || techRes);
// //                 cacheTechnicalSEO(brandDomain, techRes);
// //             } catch (err) {
// //                 console.warn('❌ Technical SEO failed:', err);
// //             }
// //             } else {
// //             console.warn('⚠️ No brand domain, skipping Technical SEO');
// //             }

// //             // 3. GMB Ranking for the brand
// //             if (placeId && firstKeyword) {
// //             const payload = {
// //                 domain: brandDomain,
// //                 keyword: firstKeyword,
// //                 location: location || fullAddress || '',
// //                 place_ids: { brand: placeId },
// //                 force_refresh: false,
// //                 radius_km: 1.5,
// //             };
// //             console.log('📍 GMB Ranking payload:', payload);
// //             try {
// //                 const rankingRes = await auditAPI.gmbranking(payload);
// //                 console.log('✅ GMB Ranking response:', rankingRes?.data || rankingRes);
// //                 cacheGmbRanking(firstKeyword, location, placeId, rankingRes);
// //             } catch (err) {
// //                 console.warn('❌ GMB Ranking failed:', err);
// //             }
// //             } else {
// //             console.warn('⚠️ GMB Ranking skipped – placeId or keyword missing');
// //             }

// //             console.log('🎉 All background audits completed successfully.');
// //         } catch (err) {
// //             console.error('❌ Unexpected error during background audits:', err);
// //         } finally {
// //             setScoresLoading(false);
// //             advance(4);
// //         }
// //     }, [websiteUrl, competitors, placeId, tags, location, fullAddress]);

//     // Replace handleCompetitorsConfirm with this:
// // const handleCompetitorsConfirm = useCallback(async () => {
// //   setScoresLoading(true);

// //   let firstKeyword = tags.length > 0 ? tags[0] : null;
// //   if (!firstKeyword) {
// //     try {
// //       const stored = localStorage.getItem('auditFormData');
// //       if (stored) {
// //         const formData = JSON.parse(stored);
// //         const pill = formData.pillarKeywords;
// //         if (pill && pill.length) firstKeyword = pill[0];
// //       }
// //     } catch (e) {}
// //   }

// //   const brandDomain = cleanDomain(websiteUrl) || websiteUrl;
// //   const domainsToFetch = [brandDomain];
// //   competitors.forEach(comp => {
// //     if (comp.website) domainsToFetch.push(cleanDomain(comp.website) || comp.website);
// //   });
// //   const uniqueDomains = [...new Set(domainsToFetch)];

// //   // ── helper: check cache before hitting API ──────────────────────
// //   const isCached = (key, format = 'timestamp') => {
// //     const raw = localStorage.getItem(key);
// //     if (!raw) return false;
// //     try {
// //       const parsed = JSON.parse(raw);
// //       const ts = format === 'ts' ? parsed.ts : parsed.timestamp;
// //       return ts && Date.now() - ts < 24 * 60 * 60 * 1000;
// //     } catch { return false; }
// //   };

// //   try {
// //     // 1. Authority — skip if already cached (uses { ts, d } format)
// //     const authorityPromises = uniqueDomains.map(async (domain) => {
// //       if (isCached(`domainAuthority_${domain}`, 'ts')) {
// //         console.log(`⚡ Authority cache hit: ${domain}`);
// //         return;
// //       }
// //       try {
// //         const res = await auditAPI.authorityAnalysis({ BrandURL: `https://${domain}` });
// //         cacheDomainAuthority(domain, res);
// //       } catch (err) {
// //         console.warn(`❌ Authority failed for ${domain}:`, err);
// //       }
// //     });
// //     await Promise.all(authorityPromises);

// //     // 2. PageSpeed — skip if already cached
// //     const pageSpeedPromises = uniqueDomains.map(async (domain) => {
// //       if (isCached(`pageSpeedRaw_${domain}`)) {
// //         console.log(`⚡ PageSpeed cache hit: ${domain}`);
// //         return;
// //       }
// //       try {
// //         const res = await auditAPI.pagespeedAnalysis({ domain });
// //         cachePageSpeed(domain, res);
// //       } catch (err) {
// //         console.warn(`❌ PageSpeed failed for ${domain}:`, err);
// //       }
// //     });
// //     await Promise.all(pageSpeedPromises);

// //     // 3. Technical SEO — skip if already cached
// //     if (brandDomain) {
// //       if (isCached(`technicalSEO_${brandDomain}`)) {
// //         console.log(`⚡ Technical SEO cache hit: ${brandDomain}`);
// //       } else {
// //         try {
// //           const techRes = await auditAPI.technicalseo({ domain: brandDomain });
// //           cacheTechnicalSEO(brandDomain, techRes);
// //         } catch (err) {
// //           console.warn('❌ Technical SEO failed:', err);
// //         }
// //       }
// //     }

// //     // 4. GMB Ranking — skip if already cached
// //     if (placeId && firstKeyword) {
// //     //const cacheKey = `gmbRanking_${brandDomain}_${firstKeyword}_default_1.5`;
// //     const cacheKey = `gmbRanking_${brandDomain}_${placeId}_${firstKeyword}_default_1.5`;

// //     if (isCached(cacheKey)) {
// //         console.log(`⚡ GMB Ranking cache hit`);
// //     } else {
// //         const payload = {
// //         domain: brandDomain,
// //         keyword: firstKeyword,
// //         location: location || fullAddress || '',
// //         place_ids: { brand: placeId },
// //         force_refresh: false,
// //         radius_km: 1.5,
// //         };
// //         try {
// //         const rankingRes = await auditAPI.gmbranking(payload);
// //         cacheGmbRanking(firstKeyword, location, placeId, brandDomain, 1.5, rankingRes);
// //         } catch (err) {
// //         console.warn('❌ GMB Ranking failed:', err);
// //         }
// //     }
// //     }

// //     console.log('🎉 All background audits done.');
// //   } catch (err) {
// //     console.error('❌ Unexpected error:', err);
// //   } finally {
// //     setScoresLoading(false);
// //     advance(4);
// //   }
// // }, [websiteUrl, competitors, placeId, tags, location, fullAddress]);


// // ─── Render ───────────────────────────────────────────────────────────
// //   return (
// //     <div className="wrap">
// //         {/* ✅ Full-screen loading overlay while background audits run */}
// //         {scoresLoading && (
// //         <div style={{
// //             position: 'fixed',
// //             inset: 0,
// //             background: 'rgba(107, 79, 160, 0.15)',
// //             backdropFilter: 'blur(4px)',
// //             zIndex: 9999,
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //         }}>
// //             <div style={{
// //                 background: 'rgba(255, 255, 255, 0.96)',
// //                 borderRadius: 20,
// //                 boxShadow: '0 8px 32px rgba(107, 79, 160, 0.2)',
// //                 border: '1px solid rgba(107, 79, 160, 0.2)',
// //                 padding: '40px 36px',
// //                 width: '450px',
// //                 maxWidth: 420,
// //                 width: 'calc(100% - 32px)',
// //                 margin: '0 10px',
// //                 display: 'flex',
// //                 flexDirection: 'column',
// //                 alignItems: 'center',
// //                 gap: 16,
// //             }}>
// //                 <div className="spinner" style={{ width: 44, height: 44, borderTopColor: '#6B4FA0' }} />
// //                 <div style={{ fontWeight: 700, fontSize: 18, color: '#1C1626', textAlign: 'center' }}>
// //                     Running your brand audit…
// //                 </div>
// //                 <div style={{ fontSize: 13, color: '#6B4FA0', textAlign: 'center', lineHeight: 1.5 }}>
// //                     Fetching domain authority, page speed, technical SEO and GMB ranking. This takes 2–4 minutes.
// //                 </div>
// //                 <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4, paddingLeft: 10 }}>
// //                     {[
// //                         { icon: '🔗', label: 'Domain Authority & Backlinks' },
// //                         { icon: '⚡', label: 'Page Speed (mobile + desktop)' },
// //                         { icon: '🔧', label: 'Technical SEO audit' },
// //                         { icon: '📍', label: 'GMB local ranking' },
// //                     ].map((item, i) => (
// //                         <div key={i} style={{
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: 10,
// //                             fontSize: 13,
// //                             color: '#1C1626',
// //                             background: 'rgba(107, 79, 160, 0.06)',
// //                             borderRadius: 10,
// //                             padding: '9px 14px',
// //                         }}>
// //                             <span style={{ fontSize: 16 }}>{item.icon}</span>
// //                             <span>{item.label}</span>
// //                         </div>
// //                     ))}
// //                 </div>
// //             </div>
// //         </div>
// //     )}
// //       <header className="hdr">
// //         <div className="logo-row">
// //           {/* <div className="lmark">
// //             <svg viewBox="0 0 24 24"><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5s2.5 1.1 2.5 2.5S13.4 11.5 12 11.5z"/></svg>
// //           </div> */}
// //           {/* <span className="aname">Thistle Media</span> */}
// //         </div>
// //         <h1 className="headline">Brand <em>Audit</em> Tool</h1>
// //         <p className="sub">Fill in each step — your client's audit report builds itself.</p>
// //       </header>

// //       {/* Card 1 */}
// //       <div id="card-1" className="card">
// //         <BrandInfo
// //           onComplete={handleBrandComplete}
// //           initialBrand={brandName}
// //           initialTags={tags}
// //         />
// //       </div>

// //       {/* Card 2 */}
// //       {step >= 2 && (
// //         <div id="card-2" className="card" style={{ padding: 0, overflow: 'hidden', borderRadius: '20px' }}>
// //           <GMBProfile
// //             brandName={brandName}
// //             domain={websiteUrl}
// //             location={location}
// //             address={fullAddress}
// //             placeId={placeId}
// //             gmbLink={gmbLink}
// //             gmbData={gmbData}
// //             isLoading={gmbLoading}
// //             onConfirm={handleGMBConfirm}
// //           />
// //         </div>
// //       )}

// //       {/* Card 3 */}
// //       {step >= 3 && (
// //         <div id="card-3" className="card">
// //           <Competitors
// //             competitors={competitors}
// //             isLoading={compLoading}
// //             onConfirm={handleCompetitorsConfirm}
// //             onUpdateCompetitors={handleUpdateCompetitors}
// //             auditLoading={scoresLoading}
// //           />
// //         </div>
// //       )}
      
// //         {step >= 4 && (
// //         <div id="card-4" className="card">
// //             <DomainAuthorityPage
// //             brandName={brandName}
// //             websiteUrl={websiteUrl}
// //             competitors={competitors}
// //             onContinue={() => advance(5)}
// //             />
// //         </div>
// //         )}
// //         {step >= 5 && (
// //         <div id="card-5" className="card">
// //             <PageSpeedPage
// //             brandName={brandName}
// //             websiteUrl={websiteUrl}
// //             competitors={competitors}
// //             onContinue={() => advance(6)}
// //             />
// //         </div>
// //         )}
// //         {step >= 6 && (
// //         <div id="card-6" className="card">
// //             <TechnicalSEOPage
// //             websiteUrl={websiteUrl}
// //             onContinue={() => advance(7)}
// //             />
// //         </div>
// //         )}
// //         {step >= 7 && (
// //             <div id="card-7" className="card">
// //                 <GmbAuditPage
// //                 brandName={brandName}
// //                 websiteUrl={websiteUrl}
// //                 location={location}
// //                 placeId={placeId}
// //                 competitors={competitors}
// //                 onContinue={() => advance(8)}
// //                 />
// //             </div>
// //         )}
// //         {step >= 8 && (
// //             <div id="card-8" className="card">
// //                 <AIVisibilityPage
// //                 brandName={brandName}
// //                 pillarKeywords={tags}
// //                 location={location}
// //                 onContinue={() => advance(9)}
// //                 />
// //             </div>
// //             )}
// //         {step >= 9 && (
// //         <div id="card-9" className="card">
// //             <OverallScores
// //             brandName={brandName}
// //             websiteUrl={websiteUrl}
// //             location={location}
// //             competitors={competitors}
// //             onContinue={() => advance(10)}
// //             />
// //         </div>
// //         )}     
// //         {step >= 10 && (
// //             <div id="card-10" className="card">
// //                 <FinalVerdict />
// //             </div>
// //             )}
// //         {/* ─── Share button appears after the audit report is complete ─── */}
// //       {(step >= 10) && <ShareButton brandName={brandName} />}
      
// //       {/* Cards 4–10 (to be uncommented when ready) */}
// //       {/* 
// //       {step >= 4 && <div id="card-4" className="card"><Step4_OverallScores ... onCalculateScore={...} /></div>}
// //       ...
// //       */}
// //     </div>
// //   );
// // };

// const handleCompetitorsConfirm = useCallback(() => {
//   advance(4);
// }, []);

// // ─── Render ───────────────────────────────────────────────────────────
// return (
//   <div className="wrap">
//     <header className="hdr">
//       <h1 className="headline">Brand <em>Audit</em> Tool</h1>
//       <p className="sub">Fill in each step — your client's audit report builds itself.</p>
//     </header>

//     {/* Card 1 */}
//     <div id="card-1" className="card">
//       <BrandInfo
//         onComplete={handleBrandComplete}
//         initialBrand={brandName}
//         initialTags={tags}
//       />
//     </div>

//     {/* Card 2 */}
//     {step >= 2 && (
//       <div id="card-2" className="card" style={{ padding: 0, overflow: 'hidden', borderRadius: '20px' }}>
//         <GMBProfile
//           brandName={brandName}
//           domain={websiteUrl}
//           location={location}
//           address={fullAddress}
//           placeId={placeId}
//           gmbLink={gmbLink}
//           gmbData={gmbData}
//           isLoading={gmbLoading}
//           onConfirm={handleGMBConfirm}
//         />
//       </div>
//     )}

//     {/* Card 3 */}
//     {step >= 3 && (
//       <div id="card-3" className="card">
//         <Competitors
//           competitors={competitors}
//           isLoading={compLoading}
//           onConfirm={handleCompetitorsConfirm}
//           onUpdateCompetitors={handleUpdateCompetitors}
//         />
//       </div>
//     )}

//     {step >= 4 && (
//       <div id="card-4" className="card">
//         <DomainAuthorityPage
//           brandName={brandName}
//           websiteUrl={websiteUrl}
//           competitors={competitors}
//           onContinue={() => advance(5)}
//         />
//       </div>
//     )}

//     {step >= 5 && (
//       <div id="card-5" className="card">
//         <PageSpeedPage
//           brandName={brandName}
//           websiteUrl={websiteUrl}
//           competitors={competitors}
//           onContinue={() => advance(6)}
//         />
//       </div>
//     )}

//     {step >= 6 && (
//       <div id="card-6" className="card">
//         <TechnicalSEOPage
//           websiteUrl={websiteUrl}
//           onContinue={() => advance(7)}
//         />
//       </div>
//     )}

//     {step >= 7 && (
//       <div id="card-7" className="card">
//         <GmbAuditPage
//           brandName={brandName}
//           websiteUrl={websiteUrl}
//           location={location}
//           placeId={placeId}
//           competitors={competitors}
//           onContinue={() => advance(8)}
//         />
//       </div>
//     )}

//     {step >= 8 && (
//       <div id="card-8" className="card">
//         <AIVisibilityPage
//           brandName={brandName}
//           pillarKeywords={tags}
//           location={location}
//           onContinue={() => advance(9)}
//         />
//       </div>
//     )}

//     {step >= 9 && (
//       <div id="card-9" className="card">
//         <OverallScores
//           brandName={brandName}
//           websiteUrl={websiteUrl}
//           location={location}
//           competitors={competitors}
//           onContinue={() => advance(10)}
//         />
//       </div>
//     )}

//     {step >= 10 && (
//       <div id="card-10" className="card">
//         <FinalVerdict />
//       </div>
//     )}

//     {step >= 10 && <ShareButton brandName={brandName} />}
//   </div>
// );
// }
// export default BrandAuditWizard;

// src/components/BrandAudit/BrandAuditWizard.js
import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';
import { auditAPI } from '../../services/api';
import BrandInfo   from './BrandInfo';
import GMBProfile  from './GMBProfile';
import Competitors from './Competitors';
import OverallScores from './OverallScores';
import DomainAuthorityPage from './DomainAuthorityPage';
import PageSpeedPage from './PageSpeedPage';
import TechnicalSEOPage from './TechnicalSEOPage';
import GmbAuditPage from './GmbAuditPage'
import AIVisibilityPage from './AIVisibilityPage';
import FinalVerdict from './FinalVerdict';
import Customaudit from './Customaudit';
import { normalizeBrandName } from '../../utils/normalizeBrandName';
import ShareButton from './ShareButton';
import '../../BrandPulse.css';

// ─────────────────────────────────────────────────────────────────────────
// Helper functions (same as old AuditFormNew)
// ─────────────────────────────────────────────────────────────────────────
const cleanDomain = (url) =>
  url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// const buildFormData = (brandName, tags, websiteUrl, location, gmbLink, competitors) => {
//   const locations = [{ city: location || '', gmbLink: gmbLink || '' }];
//   const competitorUrls = competitors.map(c => c.website || '').filter(Boolean);
//   return { brandName, websiteUrl, locations, pillarKeywords: tags, competitors: competitorUrls };
// };

const buildFormData = (brandName, tags, websiteUrl, location, gmbLink, competitors, placeId) => {
  const locations = [{ city: location || '', gmbLink: gmbLink || '' }];
  const competitorUrls = competitors.map(c => c.website || '').filter(Boolean);
  return { brandName, websiteUrl, locations, pillarKeywords: tags, competitors: competitorUrls, placeId };
};


const persistAuditData = (brandName, tags, websiteUrl, location, gmbLink, competitors, setLastAuditInfo,placeId) => {
  const formData = buildFormData(brandName, tags, websiteUrl, location, gmbLink, competitors);
  localStorage.setItem('auditFormData', JSON.stringify(formData));
  const auditInfo = {
    brandName,
    domain: websiteUrl,
    location: location || '',
    competitorCount: formData.competitors.length,
    auditDate: new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
  };
  localStorage.setItem('lastAuditInfo', JSON.stringify(auditInfo));
  setLastAuditInfo(auditInfo);
};

const loadSavedData = () => {
  const saved = localStorage.getItem('auditFormData');
  if (!saved) return null;
  try {
    const data = JSON.parse(saved);
    return {
      brandName: data.brandName || '',
      tags: data.pillarKeywords || [],
      websiteUrl: data.websiteUrl || '',
      location: data.locations?.[0]?.city || '',
      gmbLink: data.locations?.[0]?.gmbLink || '',
      competitorUrls: data.competitors || [],
    };
  } catch { return null; }
};

// Helper to extract and normalize authority metrics (copy from DomainAuthorityPage)
const extractAuthorityMetrics = (response, domain) => {
  const d = response?.data;
  if (!d) return null;
  // Try various response shapes (same as DomainAuthorityPage)
  if (d.data?.domain_authority !== undefined) return d.data;
  if (d.domain_authority !== undefined) return d;
  if (d.data && typeof d.data === 'object') {
    if (d.data[domain]?.domain_authority !== undefined) return d.data[domain];
    const key = Object.keys(d.data).find(k => k !== 'insights' && d.data[k]?.domain_authority);
    if (key) return d.data[key];
  }
  if (d[domain]?.domain_authority !== undefined) return d[domain];
  if (d.success && d.data) {
    const inner = d.data;
    if (inner.domain_authority !== undefined) return inner;
    if (inner[domain]?.domain_authority !== undefined) return inner[domain];
  }
  return null;
};

const normalizeAuthorityData = (raw, domain) => {
  const cap = (v) => Math.min(Math.max(parseInt(v) || 0, 0), 100);
  return {
    domain:           raw.domain ?? domain,
    domain_authority: cap(raw.domain_authority),
    page_authority:   cap(raw.page_authority),
    spam_score:       cap(raw.spam_score),
    spam_risk:        raw.spam_risk ?? 'UNKNOWN',
    referring_domains: parseInt(raw.referring_domains) || 0,
    total_backlinks:   parseInt(raw.total_backlinks)   || 0,
    domain_age_years:  parseFloat(raw.domain_age_years) || 0,
    source:           raw.source ?? 'unknown',
    insights:         raw.insights ?? '',
  };
};

const cacheDomainAuthority = (domain, response) => {
  try {
    const raw = extractAuthorityMetrics(response, domain);
    if (raw) {
      const normalized = normalizeAuthorityData(raw, domain);
      const cacheKey = `domainAuthority_${domain}`;
      localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), d: normalized }));
      console.log(`✅ Cached Domain Authority for ${domain}`);
    } else {
      console.warn(`⚠️ Could not extract authority metrics for ${domain}`);
    }
  } catch (e) { console.warn('Cache Domain Authority failed', e); }
};


// ─────────────────────────────────────────────────────────────────────────
// Cache helpers (matching LoadingScreen)
// ─────────────────────────────────────────────────────────────────────────
const cachePageSpeed = (domain, response) => {
  try {
    const cacheKey = `pageSpeedRaw_${domain}`;
    const domainKey = domain in response.data ? domain : Object.keys(response.data)[0];
    const pageData = response.data[domainKey];
    if (pageData) {
      localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: pageData }));
    }
  } catch (e) { console.warn('Cache PageSpeed failed', e); }
};

const cacheTechnicalSEO = (domain, response) => {
  try {
    const cacheKey = `technicalSEO_${cleanDomain(domain)}`;
    const techData = response?.data || response;
    if (!techData) return;
    const summary = techData.summary_card || {};
    const metrics = techData.metrics || {};
    const mapped = {
      pages_indexed: summary.pages_indexed?.value ?? 0,
      schema_count: summary.schema_markup?.count ?? 0,
      broken_links: summary.broken_links?.count ?? 0,
      alt_coverage: summary.image_alt_coverage?.coverage ?? 0,
      ssl_status: {
        status: summary.https_ssl?.status === 'Secure' ? 'Secure' : (summary.https_ssl?.status === 'Expiring Soon' ? 'Expiring Soon' : 'Unknown'),
        details: summary.https_ssl?.expires_in_days ? `Certificate expires in ${summary.https_ssl.expires_in_days} days` : '',
      },
      robots_txt: {
        status: metrics.robots_txt?.status === 'present' ? 'Present' : 'Missing',
        url: `${domain}/robots.txt`,
        details: metrics.robots_txt?.analysis?.sitemap_references?.length ? 'Sitemap referenced' : '',
      },
      sitemap: {
        status: summary.sitemap?.status === 'Present' ? 'Present' : 'Missing',
        url: `${domain}/sitemap.xml`,
        details: summary.sitemap?.url_count ? `${summary.sitemap.url_count} URLs` : '',
      },
      google_analytics: { detected: metrics.google_analytics?.detected ?? false, id: metrics.google_analytics?.measurement_id || '' },
      google_tag_manager: { detected: metrics.google_tag_manager?.detected ?? false, id: metrics.google_tag_manager?.container_id || '' },
      meta_pixel: { detected: metrics.meta_pixel?.detected ?? false },
      mobile_usability: { status: summary.mobile_usability?.status === 'Pass' ? 'Pass' : 'Issues Found', details: '' },
      core_web_vitals: { status: summary.core_web_vitals?.status === 'Pass' ? 'Pass' : 'Fail', details: '' },
      schema_markup_types: { found: summary.schema_markup?.types || [], missing: summary.schema_markup?.missing || [], count: summary.schema_markup?.count ?? 0 },
      meta_title_issues: { count: summary.meta_title_issues?.count ?? 0, details: summary.meta_title_issues?.display || '' },
      canonical_tags: { status: metrics.canonical_issues?.status === 'good' ? 'Present' : 'Needs Improvement', details: '' },
      broken_links_details: { count: summary.broken_links?.count ?? 0, internal: 0, external: 0 },
      insight: techData.ai_insight?.insight || '',
    };
    localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: mapped }));
  } catch (e) { console.warn('Cache TechnicalSEO failed', e); }
};

// Placeholder for GMB ranking (similar to LoadingScreen's get_ranking)
// const cacheGmbRanking = (keyword, location, placeId, response) => {
//   // We'll store a simplified version; the actual ranking data structure can be matched later
//   try {
//     const cacheKey = `gmbRanking_${keyword}_${location}_${placeId}`;
//     localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: response?.data || response }));
//   } catch (e) { console.warn('Cache GMB ranking failed', e); }
// };

const cacheGmbRanking = (keyword, location, placeId, domain, gridRadius = 1.5, response) => {
  try {
    const centerKey = 'default';
    const cacheKey = `gmbRanking_${domain}_${placeId}_${keyword}_${centerKey}_${gridRadius}`;

    const rankingData = response?.data;
    let grid = null, centerCellTop = [], center = null;

    if (rankingData?.ranking?.results?.brand?.grid) {
      grid         = rankingData.ranking.results.brand.grid;
      centerCellTop = rankingData.ranking.center_cell_top || [];
      center        = rankingData.ranking.center;
    } else if (rankingData?.results?.brand?.grid) {
      grid         = rankingData.results.brand.grid;
      centerCellTop = rankingData.center_cell_top || [];
      center        = rankingData.center;
    }

    localStorage.setItem(cacheKey, JSON.stringify({
      timestamp: Date.now(),
      data: { grid, centerCellTop, center }
    }));
    console.log(`✅ Cached GMB Ranking: ${cacheKey}`);
  } catch (e) {
    console.warn('Cache GMB ranking failed', e);
  }
};

// ─────────────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────────────
const BrandAuditWizard = () => {
  const navigate = useNavigate();
  const { setLastAuditInfo } = useApp();

  const [step, setStep] = useState(1);

  // Step 1 data
  const [brandName, setBrandName] = useState('');
  const [tags, setTags] = useState([]);

  // Step 2 data
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [location, setLocation] = useState('');
  const [placeId, setPlaceId] = useState('');
  const [gmbLink, setGmbLink] = useState('');
  const [gmbData, setGmbData] = useState(null);
  const [gmbLoading, setGmbLoading] = useState(false);
  const [fullAddress, setFullAddress] = useState('');  
  const [scoresLoading, setScoresLoading] = useState(false);  
  // Step 3 data
  const [competitors, setCompetitors] = useState([]);
  const [compLoading, setCompLoading] = useState(false);

  // ─── Load saved data on mount ─────────────────────────────────────────
  useEffect(() => {
    const saved = loadSavedData();
    if (saved) {
      setBrandName(saved.brandName);
      setTags(saved.tags);
      setWebsiteUrl(saved.websiteUrl);
      setLocation(saved.location);
      setGmbLink(saved.gmbLink);
      // ✅ Only restore competitors if they belong to the same brand
      const savedCompetitors = localStorage.getItem('competitors_list');
      const savedBrand = localStorage.getItem('competitors_brand');
    
      if (savedCompetitors && savedBrand === saved.brandName) {
        try { setCompetitors(JSON.parse(savedCompetitors)); } catch {}
      } 
        else {
        // Different brand — clear stale competitors
        localStorage.removeItem('competitors_list');
        localStorage.removeItem('competitors_brand');
        setCompetitors([]);
        }
    }
    }, []);

//       else if (saved.competitorUrls.length) {
//         const comps = saved.competitorUrls.map((url, idx) => ({
//           id: Date.now() + idx,
//           website: url,
//           name: '',
//           rating: 0,
//           reviews: 0,
//           isManual: true,
//         }));
//         setCompetitors(comps);
//         localStorage.setItem('competitors_list', JSON.stringify(comps));
//       }
//     }
//   }, []);

  // ─── Persist data whenever important state changes ────────────────────
  useEffect(() => {
    if (brandName && tags.length) {
      persistAuditData(brandName, tags, websiteUrl, location, gmbLink, competitors, setLastAuditInfo,placeId);
    }
    if (competitors.length) {
      localStorage.setItem('competitors_list', JSON.stringify(competitors));
    }
  }, [brandName, tags, websiteUrl, location, gmbLink, competitors, setLastAuditInfo,placeId]);

  const advance = (nextStep) => {
    setStep(nextStep);
    setTimeout(() => {
      const el = document.getElementById(`card-${nextStep}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  // ─── Step 1 complete ──────────────────────────────────────────────────
  const handleBrandComplete = useCallback(({ brandName: bn, tags: t, websiteUrl: wu, placeId: pid, location: loc, fullAddress: fa, gmbLink: gl }) => {
    
    // ✅ If brand changed, wipe stale caches so nothing bleeds through
    const prevBrand = localStorage.getItem('competitors_brand');
    if (prevBrand && prevBrand !== bn) {
        console.log(`🔄 Brand changed from "${prevBrand}" to "${bn}" — clearing caches`);
        localStorage.removeItem('competitors_list');
        localStorage.removeItem('competitors_brand');
        // Clear audit caches so new brand gets fresh data
        const prevDomain = cleanDomain(localStorage.getItem('auditFormData')
        ? JSON.parse(localStorage.getItem('auditFormData')).websiteUrl : '');
        if (prevDomain) {
        localStorage.removeItem(`domainAuthority_${prevDomain}`);
        localStorage.removeItem(`pageSpeedRaw_${prevDomain}`);
        localStorage.removeItem(`technicalSEO_${prevDomain}`);
        localStorage.removeItem(`overallScore_${prevDomain}`);
        clearAIVisibilityCache(prevDomain);
        }
        setCompetitors([]);
    }
    
    //setBrandName(bn);
    setBrandName(normalizeBrandName(bn));
    setTags(t);
    setWebsiteUrl(wu);
    setPlaceId(pid);
    setLocation(loc);
    setFullAddress(fa);
    setGmbLink(gl);
    advance(2);
  }, []);

  const clearAIVisibilityCache = (domain) => {
  if (!domain) return;
  const prefix = `aiVisibility_${domain}_`;
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(prefix)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(k => localStorage.removeItem(k));
  if (keysToRemove.length > 0) {
    console.log(`🗑️ Cleared ${keysToRemove.length} AI visibility cache entries for ${domain}`);
  }
};

  // ─── Step 2 complete ──────────────────────────────────────────────────
//   const handleGMBConfirm = useCallback(async (confirmedData) => {
//     if (confirmedData) setGmbData(confirmedData);
//     advance(3);    
//     setCompLoading(true);
//     try {
//       const res = await auditAPI.autoDiscover({
//         domain: cleanDomain(websiteUrl) || websiteUrl,
//         brand: brandName,
//         location: location,
//         pillar_keywords: tags,
//         brand_rating:  resolvedGmbData?.rating              ?? 
//                        resolvedGmbData?.reviews?.rating     ?? 0,
//         brand_reviews: resolvedGmbData?.user_ratings_total  ?? 
//                        resolvedGmbData?.reviews?.count      ?? 0,
//         force_refresh: true,
//       });
      
//     const data = res?.data?.data || res?.data || {};
//     const rawCompetitors = data.competitors || [];
//     const mappedCompetitors = rawCompetitors.map((c, idx) => ({
//       id:       c.place_id || Date.now() + idx,
//       name:     c.name || '',
//       website:  c.website || '',
//       rating:   c.rating || 0,
//       reviews:  c.user_ratings_total || 0,
//       isManual: false,
//     }));

//     setCompetitors(mappedCompetitors);
//     localStorage.setItem('competitors_list', JSON.stringify(mappedCompetitors));
//     localStorage.setItem('competitors_brand', brandName); // ✅ tag with brand
//   } catch (err) {
//     console.error('Competitor fetch failed', err);
//   } finally {
//     setCompLoading(false);
//   }
// }, [brandName, location, tags]);

    const handleGMBConfirm = useCallback(async (confirmedData) => {
    const resolvedGmbData = confirmedData || gmbData;
    if (confirmedData) setGmbData(confirmedData);
    advance(3);    
    setCompLoading(true);
    try {
        console.log("domain",websiteUrl)
        console.log("Brand",brandName)
        
      const res = await auditAPI.autoDiscover({
        domain: cleanDomain(websiteUrl) || websiteUrl,   // ── NEW
        brand: brandName,
        location: location,
        pillar_keywords: tags,
        force_refresh: true,
        // ── NEW: pass brand strength so backend filters weak competitors ──
        brand_rating:  resolvedGmbData?.rating              ?? 
                       resolvedGmbData?.reviews?.rating     ?? 0,
        brand_reviews: resolvedGmbData?.user_ratings_total  ?? 
                       resolvedGmbData?.reviews?.count      ?? 0,
      });
      
    const data = res?.data?.data || res?.data || {};
    const rawCompetitors = data.competitors || [];
    const mappedCompetitors = rawCompetitors.map((c, idx) => ({
      id:       c.place_id || Date.now() + idx,
      name:     normalizeBrandName(c.name || ''),   // ── normalize competitor names too
      website:  c.website || '',
      rating:   c.rating || 0,
      reviews:  c.user_ratings_total || 0,
      isManual: false,
    }));

    setCompetitors(mappedCompetitors);
    localStorage.setItem('competitors_list', JSON.stringify(mappedCompetitors));
    localStorage.setItem('competitors_brand', brandName);
  } catch (err) {
    console.error('Competitor fetch failed', err);
  } finally {
    setCompLoading(false);
  }
}, [brandName, location, tags, gmbData]);  // ── added gmbData to deps


    const handleUpdateCompetitors = useCallback((updated) => {
    setCompetitors(updated);
    localStorage.setItem('competitors_list', JSON.stringify(updated));
    localStorage.setItem('competitors_brand', brandName); // ✅ tag with current brand
    }, [brandName]);


  // ─── Step 3 complete – fire background API calls for PageSpeed, Technical SEO, Ranking ───
//   const handleCompetitorsConfirm = useCallback(async () => {
//         setScoresLoading(true);
//         console.log('🚀 Starting background audits (PageSpeed, Technical SEO, GMB Ranking)...');

//         // Get keyword from state, fallback to localStorage
//         let firstKeyword = tags.length > 0 ? tags[0] : null;
//         if (!firstKeyword) {
//             try {
//             const stored = localStorage.getItem('auditFormData');
//             if (stored) {
//                 const formData = JSON.parse(stored);
//                 const pill = formData.pillarKeywords;
//                 if (pill && pill.length) firstKeyword = pill[0];
//             }
//             } catch (e) {}
//         }
//         console.log('📌 Using keyword for ranking:', firstKeyword);

//         const brandDomain = cleanDomain(websiteUrl) || websiteUrl;
//         const domainsToFetch = [brandDomain];
//         competitors.forEach(comp => {
//             if (comp.website) {
//             const compDomain = cleanDomain(comp.website) || comp.website;
//             domainsToFetch.push(compDomain);
//             }
//         });
//         const uniqueDomains = [...new Set(domainsToFetch)];
//         console.log('🌐 Domains for PageSpeed:', uniqueDomains);

//         try {

//             const authorityPromises = uniqueDomains.map(async (domain) => {
//             try {
//                 const res = await auditAPI.authorityAnalysis({ BrandURL: `https://${domain}` });
//                 console.log(`✅ Authority response for ${domain}:`, res?.data || res);
//                 cacheDomainAuthority(domain, res);
//             } catch (err) {
//                 console.warn(`❌ Authority failed for ${domain}:`, err);
//             }
//             });
//             await Promise.all(authorityPromises);

//             // 1. PageSpeed for brand and competitors (parallel)
//             const pageSpeedPromises = uniqueDomains.map(async (domain) => {
//             try {
//                 const res = await auditAPI.pagespeedAnalysis({ domain });
//                 console.log(`✅ PageSpeed response for ${domain}:`, res?.data || res);
//                 cachePageSpeed(domain, res);
//                 return res;
//             } catch (err) {
//                 console.warn(`❌ PageSpeed failed for ${domain}:`, err);
//             }
//             });
//             await Promise.all(pageSpeedPromises);

//             // 2. Technical SEO for brand only
//             if (brandDomain) {
//             console.log('🔧 Fetching Technical SEO for:', brandDomain);
//             try {
//                 const techRes = await auditAPI.technicalseo({ domain: brandDomain });
//                 console.log('✅ Technical SEO response:', techRes?.data || techRes);
//                 cacheTechnicalSEO(brandDomain, techRes);
//             } catch (err) {
//                 console.warn('❌ Technical SEO failed:', err);
//             }
//             } else {
//             console.warn('⚠️ No brand domain, skipping Technical SEO');
//             }

//             // 3. GMB Ranking for the brand
//             if (placeId && firstKeyword) {
//             const payload = {
//                 domain: brandDomain,
//                 keyword: firstKeyword,
//                 location: location || fullAddress || '',
//                 place_ids: { brand: placeId },
//                 force_refresh: false,
//                 radius_km: 1.5,
//             };
//             console.log('📍 GMB Ranking payload:', payload);
//             try {
//                 const rankingRes = await auditAPI.gmbranking(payload);
//                 console.log('✅ GMB Ranking response:', rankingRes?.data || rankingRes);
//                 cacheGmbRanking(firstKeyword, location, placeId, rankingRes);
//             } catch (err) {
//                 console.warn('❌ GMB Ranking failed:', err);
//             }
//             } else {
//             console.warn('⚠️ GMB Ranking skipped – placeId or keyword missing');
//             }

//             console.log('🎉 All background audits completed successfully.');
//         } catch (err) {
//             console.error('❌ Unexpected error during background audits:', err);
//         } finally {
//             setScoresLoading(false);
//             advance(4);
//         }
//     }, [websiteUrl, competitors, placeId, tags, location, fullAddress]);

    // Replace handleCompetitorsConfirm with this:
const handleCompetitorsConfirm = useCallback(async () => {
  setScoresLoading(true);

  let firstKeyword = tags.length > 0 ? tags[0] : null;
  if (!firstKeyword) {
    try {
      const stored = localStorage.getItem('auditFormData');
      if (stored) {
        const formData = JSON.parse(stored);
        const pill = formData.pillarKeywords;
        if (pill && pill.length) firstKeyword = pill[0];
      }
    } catch (e) {}
  }

  const brandDomain = cleanDomain(websiteUrl) || websiteUrl;
  const domainsToFetch = [brandDomain];
  competitors.forEach(comp => {
    if (comp.website) domainsToFetch.push(cleanDomain(comp.website) || comp.website);
  });
  const uniqueDomains = [...new Set(domainsToFetch)];

  // ── helper: check cache before hitting API ──────────────────────
  const isCached = (key, format = 'timestamp') => {
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    try {
      const parsed = JSON.parse(raw);
      const ts = format === 'ts' ? parsed.ts : parsed.timestamp;
      return ts && Date.now() - ts < 24 * 60 * 60 * 1000;
    } catch { return false; }
  };

  try {
    // 1. Authority — skip if already cached (uses { ts, d } format)
    const authorityPromises = uniqueDomains.map(async (domain) => {
      if (isCached(`domainAuthority_${domain}`, 'ts')) {
        console.log(`⚡ Authority cache hit: ${domain}`);
        return;
      }
      try {
        const res = await auditAPI.authorityAnalysis({ BrandURL: `https://${domain}` });
        cacheDomainAuthority(domain, res);
      } catch (err) {
        console.warn(`❌ Authority failed for ${domain}:`, err);
      }
    });
    await Promise.all(authorityPromises);

    // 2. PageSpeed — skip if already cached
    const pageSpeedPromises = uniqueDomains.map(async (domain) => {
      if (isCached(`pageSpeedRaw_${domain}`)) {
        console.log(`⚡ PageSpeed cache hit: ${domain}`);
        return;
      }
      try {
        const res = await auditAPI.pagespeedAnalysis({ domain });
        cachePageSpeed(domain, res);
      } catch (err) {
        console.warn(`❌ PageSpeed failed for ${domain}:`, err);
      }
    });
    await Promise.all(pageSpeedPromises);

    // 3. Technical SEO — skip if already cached
    if (brandDomain) {
      if (isCached(`technicalSEO_${brandDomain}`)) {
        console.log(`⚡ Technical SEO cache hit: ${brandDomain}`);
      } else {
        try {
          const techRes = await auditAPI.technicalseo({ domain: brandDomain });
          cacheTechnicalSEO(brandDomain, techRes);
        } catch (err) {
          console.warn('❌ Technical SEO failed:', err);
        }
      }
    }

    // 4. GMB Ranking — skip if already cached
    if (placeId && firstKeyword) {
    //const cacheKey = `gmbRanking_${brandDomain}_${firstKeyword}_default_1.5`;
    const cacheKey = `gmbRanking_${brandDomain}_${placeId}_${firstKeyword}_default_1.5`;

    if (isCached(cacheKey)) {
        console.log(`⚡ GMB Ranking cache hit`);
    } else {
        const payload = {
        domain: brandDomain,
        keyword: firstKeyword,
        location: location || fullAddress || '',
        place_ids: { brand: placeId },
        force_refresh: false,
        radius_km: 1.5,
        };
        try {
        const rankingRes = await auditAPI.gmbranking(payload);
        cacheGmbRanking(firstKeyword, location, placeId, brandDomain, 1.5, rankingRes);
        } catch (err) {
        console.warn('❌ GMB Ranking failed:', err);
        }
    }
    }

    console.log('🎉 All background audits done.');
  } catch (err) {
    console.error('❌ Unexpected error:', err);
  } finally {
    setScoresLoading(false);
    advance(4);
  }
}, [websiteUrl, competitors, placeId, tags, location, fullAddress]);

  // ─── Render ───────────────────────────────────────────────────────────
  return (
    <div className="wrap">
        {/* ✅ Full-screen loading overlay while background audits run */}
        {scoresLoading && (
        <div style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(107, 79, 160, 0.15)',
            backdropFilter: 'blur(4px)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.96)',
                borderRadius: 20,
                boxShadow: '0 8px 32px rgba(107, 79, 160, 0.2)',
                border: '1px solid rgba(107, 79, 160, 0.2)',
                padding: '40px 36px',
                width: '450px',
                maxWidth: 420,
                width: 'calc(100% - 32px)',
                margin: '0 10px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 16,
            }}>
                <div className="spinner" style={{ width: 44, height: 44, borderTopColor: '#6B4FA0' }} />
                <div style={{ fontWeight: 700, fontSize: 18, color: '#1C1626', textAlign: 'center' }}>
                    Running your brand audit…
                </div>
                <div style={{ fontSize: 13, color: '#6B4FA0', textAlign: 'center', lineHeight: 1.5 }}>
                    Fetching domain authority, page speed, technical SEO and GMB ranking. This takes 2–4 minutes.
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4, paddingLeft: 10 }}>
                    {[
                        { icon: '🔗', label: 'Domain Authority & Backlinks' },
                        { icon: '⚡', label: 'Page Speed (mobile + desktop)' },
                        { icon: '🔧', label: 'Technical SEO audit' },
                        { icon: '📍', label: 'GMB local ranking' },
                    ].map((item, i) => (
                        <div key={i} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            fontSize: 13,
                            color: '#1C1626',
                            background: 'rgba(107, 79, 160, 0.06)',
                            borderRadius: 10,
                            padding: '9px 14px',
                        }}>
                            <span style={{ fontSize: 16 }}>{item.icon}</span>
                            <span>{item.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )}
      <header className="hdr">
        <div className="logo-row">
          {/* <div className="lmark">
            <svg viewBox="0 0 24 24"><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5s2.5 1.1 2.5 2.5S13.4 11.5 12 11.5z"/></svg>
          </div> */}
          {/* <span className="aname">Thistle Media</span> */}
        </div>
        <h1 className="headline">Brand <em>Audit</em> Tool</h1>
        <p className="sub">Fill in each step — your client's audit report builds itself.</p>
      </header>

      {/* Card 1 */}
      <div id="card-1" className="card">
        <BrandInfo
          onComplete={handleBrandComplete}
          initialBrand={brandName}
          initialTags={tags}
        />
      </div>

      {/* Card 2 */}
      {step >= 2 && (
        <div id="card-2" className="card" style={{ padding: 0, overflow: 'hidden', borderRadius: '20px' }}>
          <GMBProfile
            brandName={brandName}
            domain={websiteUrl}
            location={location}
            address={fullAddress}
            placeId={placeId}
            gmbLink={gmbLink}
            gmbData={gmbData}
            isLoading={gmbLoading}
            onConfirm={handleGMBConfirm}
          />
        </div>
      )}

      {/* Card 3 */}
      {step >= 3 && (
        <div id="card-3" className="card">
          <Competitors
            competitors={competitors}
            isLoading={compLoading}
            onConfirm={handleCompetitorsConfirm}
            onUpdateCompetitors={handleUpdateCompetitors}
            auditLoading={scoresLoading}
          />
        </div>
      )}
      {step >= 4 && (
        <div id="card-4" className="card">
            <OverallScores
            brandName={brandName}
            websiteUrl={websiteUrl}
            location={location}
            competitors={competitors}
            onContinue={() => advance(5)}
            />
        </div>
        )} 
        {step >= 5 && (
            <div id="card-9" className="card">
                <AIVisibilityPage
                brandName={brandName}
                pillarKeywords={tags}
                competitors={competitors}
                location={location}
                 onContinue={() => advance(6)}
                />
            </div>
            )}
        {step >= 6 && (
        <div id="card-5" className="card">
            <DomainAuthorityPage
            brandName={brandName}
            websiteUrl={websiteUrl}
            competitors={competitors}
            onContinue={() => advance(7)}
            />
        </div>
        )}
        {step >= 7 && (
        <div id="card-6" className="card">
            <PageSpeedPage
            brandName={brandName}
            websiteUrl={websiteUrl}
            competitors={competitors}
            onContinue={() => advance(8)}
            />
        </div>
        )}
        {step >= 8 && (
        <div id="card-7" className="card">
            <TechnicalSEOPage
            websiteUrl={websiteUrl}
            onContinue={() => advance(9)}
            />
        </div>
        )}
        {step >= 9 && (
            <div id="card-8" className="card">
                <GmbAuditPage
                brandName={brandName}
                websiteUrl={websiteUrl}
                location={location}
                placeId={placeId}
                competitors={competitors}
                onContinue={() => advance(10)}
                />
            </div>
        )}

        {step >= 10 && (
          <div id="card-custom" className="card">
            <Customaudit
              brandName={brandName}
              onContinue={() => advance(11)}
            />
          </div>
        )}
        
        {step >= 11 && (
            <div id="card-10" className="card">
                <FinalVerdict />
            </div>
            )}
        {/* ─── Share button appears after the audit report is complete ─── */}
      {(step >= 10) && <ShareButton brandName={brandName} />}
      
      {/* Cards 4–10 (to be uncommented when ready) */}
      {/* 
      {step >= 4 && <div id="card-4" className="card"><Step4_OverallScores ... onCalculateScore={...} /></div>}
      ...
      */}
    </div>
  );
};

export default BrandAuditWizard;

